module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('pageTitle', {
    attrs: {
      "title": "修改绑定邮箱"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.5rem"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0.8rem"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#666666",
      "font-weight": "bold"
    }
  }, [_vm._v(" 新邮箱 ")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserPhone),
      expression: "UserPhone"
    }],
    staticStyle: {
      "height": "0.5rem",
      "font-size": "0.28rem",
      "margin-left": "0.3rem",
      "width": "5.4rem",
      "border": "0",
      "outline": "0"
    },
    attrs: {
      "placeholder": "请输入邮箱账号"
    },
    domProps: {
      "value": (_vm.UserPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.8rem",
      "margin-top": "0.4rem"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#666666",
      "font-weight": "bold"
    }
  }, [_vm._v(" 附加码 ")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FJM),
      expression: "FJM"
    }],
    staticStyle: {
      "height": "0.5rem",
      "font-size": "0.28rem",
      "margin-left": "0.3rem",
      "width": "2.8rem",
      "border": "0",
      "outline": "0"
    },
    attrs: {
      "placeholder": "请输入附加码"
    },
    domProps: {
      "value": (_vm.FJM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.FJM = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "1.9rem",
      "float": "right",
      "margin-top": "-0.2rem"
    },
    attrs: {
      "src": _vm.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.8rem",
      "margin-top": "0.4rem"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#666666",
      "font-weight": "bold"
    }
  }, [_vm._v(" 验证码 ")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.YZM),
      expression: "YZM"
    }],
    staticStyle: {
      "height": "0.5rem",
      "font-size": "0.28rem",
      "margin-left": "0.3rem",
      "width": "2.8rem",
      "border": "0",
      "outline": "0"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.YZM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.YZM = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }],
    on: {
      "click": _vm.getYZM
    }
  }, [_c('input', {
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#27ba69",
      "height": "0.75rem",
      "border": "none",
      "width": "1.9rem",
      "color": "white"
    },
    attrs: {
      "id": "getYZM",
      "type": "button",
      "value": "获取"
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WaitTime),
      expression: "WaitTime"
    }],
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#eeeeee",
      "height": "0.75rem",
      "border": "none",
      "width": "1.9rem",
      "color": "#999"
    },
    attrs: {
      "id": "getYZM",
      "type": "button"
    },
    domProps: {
      "value": (_vm.WaitTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.WaitTime = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('mu-divider')], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.6rem"
    },
    style: ({
      width: '90%',
      height: ' 1rem'
    }),
    attrs: {
      "label": "修 改",
      "primary": ""
    },
    on: {
      "click": _vm.Change
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a48572a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/ChangeEMail.vue
// module id = 1471
// module chunks = 18